import type { IWixAPI } from '@wix/yoshi-flow-editor';

export function resolveCurrencyLocale(wixCodeApi: IWixAPI): string | undefined {
  const { multilingual } = wixCodeApi.window;
  return multilingual.isEnabled
    ? multilingual.siteLanguages.find((language) => language.languageCode === multilingual.currentLanguage)?.locale
    : wixCodeApi.site.regionalSettings ?? wixCodeApi.site.language;
}
